import styled from 'styled-components';

export const StyledBadge = styled.span`
  ${({ theme }) => theme.objects.Badge.Base}
`;
